import React, { useState } from 'react'
import { TransportProvider } from './Context/transport/TransportProvider'
import { Routes, Route } from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import Header from '../src/ui/views/share/components/header';
// import Home from './Routes/Home/Home';
import Home from '../src/ui/views/home';
// import Flights from './Routes/Flights/Flights';
import Procedures from './Routes/Procedures/Procedures';
import Doctors from './Routes/Doctors/Doctors';
import Doctor from './Routes/Doctor/Doctor';
import Nurses from './Routes/Nurses/Nurses';
import Nurse from './Routes/Nurse/Nurse';
import Turism from './Routes/Turism/Turism';
import Allies from './Routes/Allies/Allies';
import Register from './Routes/Register/Register';
import About from './Routes/About/About';
import Recovery from './Routes/Recovery/Recovery';
// import Footer from './Components/Footer/Footer';
import Footer from '../src/ui/views/share/components/footer';
import Tour from './Routes/Tour/Tour';
import FlightSelected from './Routes/FlightSelected/FlightSelected';
import Flights from './ui/views/flights/flights.view';
import FlightDetails from './Routes/FlightDetails/FlightDetails';
import ProcedureCategoryDetails from './Routes/ProcedureCategoryDetails/ProcedureCategoryDetails';
import ProcedureCategory from './Routes/ProcedureCategory/ProcedureCategory';
import ResultPayment from './Routes/ResultPayment/ResultPayment';
import Form from './Routes/Form/Form';
import AboutUs from './Routes/AboutUs/AboutUs';
import RateClass from './Routes/RateClass/RateClass';
import Paymentgateway from './Routes/Paymentgateway/Paymentgateway';
import ServicesCategory from './Routes/ServicesCategory/ServicesCategory';
import ShoppingCart from './Routes/ShoppingCart/ShoppingCart';
/* import Favorites from '.Routes/Favorites/Favorites'; */
import Favorites from './Routes/Favorites/Favorites';
import logoWellezy from './Routes/Home/Assets/img/LogoWhite.png'
import "./app.css"
//Redux
import { Provider } from 'react-redux';
import store from './store';
// import store from '../src/ui/store/index.js';
import Transports from './Routes/Transports/Transports';
import FlightsCheckout from './Routes/FlightsCheckout/FlightsCheckout';
import RouteVisualizador from './Routes/Visualizador/RouteVisualizador';
import PackagesRoutes from './Routes/PackagesTurism/PackagesRoutes';
import TravelRoute from './Routes/TravelRoute/TravelRoute';
import FlightRoute from './Routes/FlightRoute/FlightRoute';
import HotelRoute from './Routes/HotelRoute/HotelRoute';
import Tours from './Routes/Tours/Tours';



import TransportRoute from './Routes/TransportRoute/TransportRoute';
import PackagesRoute from './Routes/PackagesRoute/PackagesRoute';
import CarRentaRoute from './Routes/CarRentaRoute/CarRentaRoute';
import TransportResultsSearch from './Routes/TransportRoute/TransportResultsSearch';

import ProfileUser from '../src/ui/views/profileUser';
import UserRegister from './ui/views/session/register';
import UserLogin from './ui/views/session/login';

import TravelSecureRoute from './Routes/travelSecureRoute/TravelSecureRoute';
import { UserDetailsProvider } from './Context/user/userProvider';
import SpecialistRoute from './Routes/SpecialistRoute/SpecialistRoute';
import ClinicsRoute from './Routes/ClinicsRoute/ClinicsRoute';
import SpecialistDetailsRoute from './Routes/SpecialistRoute/SpecialistDetailsRoute';
import PassengerInformationForm from './ui/views/flights/passenger.information.form.view';
import HealthWellnessRoute from './Routes/HealthWellnessRoute/HealthWellnessRoute';
import PharmacyRoute from './Routes/PharmacyRoute/PharmacyRoute';
import RecoveryHouseRoute from './Routes/RecoveryHouseRoute/RecoveryHouseRoute';
import PurelyIframeFlight from './ui/views/flights/purelyIframe';
import CosmeticsRoute from './Routes/CosmeticsRoute/CosmeticsRoute';
import DetailsClinicsRoute from './Routes/ClinicsRoute/DetailsClinicsRoute';
import DetailsCosmeticsRoute from './Routes/CosmeticsRoute/DetailsCosmeticsRoute';
import DetailsRecoveryHouseRoute from './Routes/RecoveryHouseRoute/DetailsRecoveryHouseRoute';
import DetailsPharmacyRoute from './Routes/PharmacyRoute/DetailsPharmacyRoute';
import DetailsHealthRoute from './Routes/HealthWellnessRoute/DetailsHealthRoute';
import HotelResultRoute from './Routes/HotelRoute/HotelResultRoute';
import HotelDetailRoute from './Routes/HotelRoute/HotelDetailRoute';


const App = () => {
  const [carga, setCarga] = useState(true)

  window.onload = function () {
    // let carga = document.getElementById('carga-w')
    // carga.style.visibility = 'hidden';
    // carga.style.opacity = '0';
    //   setCarga(true)
  }



  const pathIframe = ['/iframe/fligths', '/register', '/login', '/iframe/fligth','/iframe/flight/search', '/iframe/flightPassengersForm'];
  let showFooterAndNav = true;
  for (let i = 0; i < pathIframe.length; i++) {
    if (window.location.pathname === pathIframe[i]) {
      showFooterAndNav = false;
      break;
    }
  }

  return (
    <Provider store={store}>
      <UserDetailsProvider>
        <TransportProvider>
          <div className='app'>
            {
              !carga ?
                <div className='carga-wellezy' id='carga-w'>
                  <img src={logoWellezy} alt="" />
                </div>
                :
                <>
                  {showFooterAndNav && <Header />}
                  <Routes>
                    <Route path='/' element={<Home/>} />
                    <Route path='/fligths' element={<FlightRoute></FlightRoute>} />
                    <Route exact path='/:id' element={<Home />} />
                    <Route path='/flight/selected' element={<FlightSelected />} />
                    <Route path='/flight/search' element={<Flights />} />
                    <Route path='/iframe/flight/search' element={<Flights />} />
                    <Route path='/flightDetails' element={<FlightDetails />} />
                    <Route path='/procedures' element={<Procedures />} />
                    <Route path='/doctors' element={<Doctors />} />
                    <Route path='/doctor/:id' element={<Doctor />} />
                    <Route path='/nurse/:id' element={<Nurse />} />
                    <Route path='/Visualizador' element={<RouteVisualizador />} />
                    <Route path='/nurses' element={<Nurses />} />
                    <Route path='/turism' element={<Turism />} />
                    <Route path='/allies' element={<Allies />} />
                    {/* <Route path='/register' element={<Register />} /> */}

                    <Route path='/hotel' element={<HotelRoute />} />
                    <Route path='/hotel/:id' element={<HotelDetailRoute />} />
                    <Route path='/hotels/:id' element={<HotelResultRoute />} />
                    <Route path='/travelSecure' element={<TravelSecureRoute />} />


                    <Route path='/transport' element={<TransportRoute></TransportRoute>} />
                    <Route path='/transport/:id' element={<TransportResultsSearch />} />
                  

                    <Route path='/about' element={<About />} />
                    <Route path='/recovery' element={<Recovery />} />
                    <Route path='/tour/:id' element={<Tour />} />
                    <Route path='/procedure/:id' element={<ProcedureCategory />} />
                    <Route path='/procedure/:id/:id' element={<ProcedureCategoryDetails />} />
                    <Route path='/services/:id' element={<ServicesCategory />} />
                    <Route path='/packages' element={<PackagesRoute />} />
                    <Route path='/carRentals' element={<CarRentaRoute />} />
                    <Route path='/packages/:id' element={<PackagesRoutes />} />
                    <Route path='/Travel' element={<TravelRoute />} />
                    <Route path='/form' element={<Form />} />
                    <Route path='/aboutus' element={<AboutUs />} />
                    <Route path='/aboutus/:id' element={<AboutUs />} />
                    <Route path='/Specialists' element={<SpecialistRoute />} />
                    <Route path='/Specialists/:id' element={<SpecialistDetailsRoute/>} />
                    <Route path='/Clinics' element={<ClinicsRoute />} />
                    <Route path='/Clinics/:id' element={<DetailsClinicsRoute/>} />
                    {/* <Route path='/transports' element={<Transports />} /> */}
                    <Route path='/flightsCheckout' element={<FlightsCheckout />} />
                    <Route path='/resultPayment' element={<ResultPayment />} />
                    <Route path='/rateClass' element={<RateClass />} />
                    <Route path='/paymentgateway' element={<Paymentgateway />} />  {/* favorites */}
                    <Route path='/shoppingCart' element={<ShoppingCart />} />
                    <Route path='/favorites' element={<Favorites />} />
                    <Route path='/tours' element={<Tours />} />
                    <Route path='/iframe/fligths' element={<FlightRoute></FlightRoute>} />
                    <Route path='/profile' element={<ProfileUser />} />
                    <Route path='/register' element={<UserRegister />} />
                    <Route path='/login' element={<UserLogin />} />

                    <Route path='/flightPassengersForm' element={<PassengerInformationForm/>} />
                    <Route path='/iframe/flightPassengersForm' element={<PassengerInformationForm/>} />
                    <Route path='/Pharmacy' element={<PharmacyRoute/>} />
                    <Route path='/Pharmacy/:id' element={<DetailsPharmacyRoute/>} />
                    <Route path='/healthWellness' element={<HealthWellnessRoute />} />
                    <Route path='/healthWellness/:id' element={<DetailsHealthRoute />} />
                    <Route path='/RecoveryHouse' element={<RecoveryHouseRoute/>} />
                    <Route path='/iframe/fligth' element={<PurelyIframeFlight/>} />
                    <Route path='/RecoveryHouse/:id' element={<DetailsRecoveryHouseRoute/>} />
                    <Route path='/Cosmetics' element={<CosmeticsRoute/>} />
                    <Route path='/Cosmetics/:id' element={<DetailsCosmeticsRoute/>} />
                  </Routes>
                  {
                    showFooterAndNav && <Footer />
                  }
                </>
            }
          </div>
        </TransportProvider>
      </UserDetailsProvider>
    </Provider>
  )
}

export default App